import type { RegisterItemList } from "@services/registers/list/type";

export const RegistersColumns: Array<{
  id: keyof RegisterItemList;
  label: string;
}> = [
  { id: "type", label: "Tipo" },
  { id: "environment", label: "Ambiente" },
  { id: "reporterName", label: "Coletado por" },
  { id: "registerDate", label: "Data" },
  { id: "attachmentsCount", label: "Anexos" },
] as const;
